import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

function useTranslationSalesChannels(keyPrefix?: string): TFunction {
  const { t } = useTranslation(Domain.SALES_CHANNELS, { keyPrefix });

  return t;
}

export default useTranslationSalesChannels;
